<template>
  <div class="header ot-header" :class="{
    'scroll-page-header': isScrolled, 'hide-header': hideHeader,
  }">
    <NotificationBar :notice="notice" :getIsMobile="getIsMobile" ref="noticeBox" v-if="notice.enable" />
    <div class="page-tab desktop" :class="{ 'hidden-toolbar': isScrolled }">
      <div class="item" v-for="(item, pIndex) in PrimaryMenu" :key="pIndex" @click="handlePageTab(item)"
        :class="{ 'active': pageTabCode === item.code }">
        <a :href="item.link"><span>{{ item.title }}</span> </a>
      </div>
    </div>
    <!-- pc -->
    <div class="menubar desktop">
      <div class="menu-wrapper">
        <div class="menu-main">
          <div class="menus">
            <button class="menu-toggle">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 23 18" id="hamburger-menu">
                <path
                  d="M22 10H1a1 1 0 1 1 0-2h21a1 1 0 0 1 0 2zm0-8H1a1 1 0 1 1 0-2h21a1 1 0 0 1 0 2zM1 16h21a1 1 0 0 1 0 2H1a1 1 0 1 1 0-2z" />
              </svg>
            </button>
            <div class="nav-left">
              <router-link class="logo-link" to="/">
                <i class="iconfont logo-icon">&#xe60e;</i>
              </router-link>
              <nav class="nav-items">
                <ul class="menu-items primary-menu">
                  <template v-for="(item, idx) in menuList">
                    <li v-show="item.show" :key="idx" @mouseenter="handleMenuItemHover(item.id)"
                      @mouseleave="handleMenuItemLeave"
                      :class="['nav1st', 'nav-item', { 'hovered': activeHoverItemId === item.id }]">
                      <a class="link" :title="item.name" :href="`${item.url}`" target="_blank" @click="closeMenu"
                        v-if="item.url">{{
                          item.name }}</a>
                      <router-link class="link" :title="item.name" :to="`/category/${item.id}`"
                        @click.native="closeMenu" v-else>{{
                          item.name }}</router-link>
                      <!-- 二级菜单 -->

                      <recursive-menu v-if="item.children && item.children.length" :item="item"
                        :menu-data="item.children" :level="1" :path="[item]" :show-back-button="false"
                        @menu-click="closeMenu" />
                    </li>
                  </template>
                </ul>
              </nav>
            </div>
            <div class="nav-right">
              <div class="nav-right-extra">

                <i class="iconfont-ot-website search-icon" @click="setSearchContentVisible">&#xe690;</i>

                <router-link class="icon_text-item" :to="{ name: 'Store-finder' }" @click.native="closeMenu">
                  <i class="iconfont-ot-website map">&#xe692;</i>
                </router-link>
                <i class="iconfont-ot-website account-icon" ref="accountIcon" @click="setAccountContentVisible">{{
                  isLogin ?
                    `&#xe693;` :
                    `&#xe693;` }}</i>
                <div class="icon_text-item menu-cart-icon" @mouseover="showCartDialog" @click="toCart">
                  <i :class="['iconfont-ot-website cart']">&#xe691;</i>
                  <span v-if="cartCount > 0"
                    :class="['cart-count', { 'cart-count-2': cartCount > 9 && cartCount < 100 }, { 'cart-count-3': cartCount > 99 }]">{{
                      cartCount >
                        99 ? `99+` : cartCount }}</span>
                </div>
              </div>
              <!-- 购物车预览 -->
              <div v-if="showCartSummary" @mouseleave="hideCartDialog"
                :class="['cart-summary', cartInfo && cartInfo.list && cartInfo.list.length ? '' : 'no-more']">
                <div class="modal-header">
                  <div class="modal-header-text" v-if="cartInfo && cartInfo.list && cartInfo.list.length">
                    商品（共{{ cartInfo.list |
                      countify }}件）</div>
                  <img @click="hideCartDialog" class="close" src="../assets/imgs/icons/onitsukatiger-close2.svg" />
                </div>
                <div class="modal-body">
                  <!-- 购物车摘要 -->
                  <template v-if="cartInfo && cartInfo.list && cartInfo.list.length">
                    <div class="cart-summary-main">
                      <div class="cart-items">
                        <div class="cart-item" v-for="item in cartInfo.list" :key="item.id">
                          <img class="cart-item-image" :src="item.images[0]" />
                          <div class="cart-item-detail">
                            <p class="bold">{{ item.name }}</p>
                            <p>颜色：{{ item.color.name }}</p>
                            <p>尺码：{{ item.size.name }}</p>
                            <p>数量：{{ item.quantity }}</p>
                          </div>
                          <div class="cart-item-price rmb-symbol">￥{{ item.price }}</div>
                        </div>
                      </div>
                      <div class="cart-subtotal">
                        <span>小计</span>
                        <span class="rmb-symbol">￥{{ cartInfo.subTotal }}</span>
                      </div>
                      <div class="cart-actions">
                        <router-link to="/cart">购物车</router-link>
                        <button @click="toShopping">继续购物</button>
                      </div>
                    </div>
                  </template>
                  <!-- 空购物车 -->
                  <template v-else>
                    <div class="empty-hits">
                      <div class="title">您的购物车为空</div>
                      <div class="empty-msg">
                        <template v-if="isLogin">
                          <router-link to="/">继续购物</router-link>
                        </template>
                        <template v-else>
                          请<router-link to="/user/login">登录</router-link>账户查看你购物车
                        </template>
                      </div>
                    </div>
                  </template>
                </div>
              </div>
            </div>
            <div class="search-box" :style="{ top: headerHeight + 'px' }" v-if="searchBoxVisible">
              <div class="search-box-wrapper">
                <div class="search-top">
                  <div class="t-l">
                    <i class="iconfont-ot-website search" @click="toSearch">&#xe690;</i>
                    <input type="text" v-model.trim="kw" ref="searchIpt" :placeholder="placeholder" @input="quickSearch"
                      @keyup.enter="toSearch">
                  </div>
                  <div class="t-r">
                    <span class="del-default-key" @click="clearSearch">删除</span>
                    <i class="iconfont-ot-website close" @click="setSearchContentVisible">&#xe6df;</i>
                  </div>
                </div>
                <div class="search-hot" v-if="!suggestion.goods.length">
                  <div class="label">热门搜索</div>
                  <div class="hot-search-list">
                    <div v-for="(item, index) in hotSearchList" :key="index">
                      <div class="item" @click="handleClickKey(item)"><a :href="item.link_url">{{ item.query_text }}</a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="search-content" v-if="suggestion.goods.length">
                  <div class="product-list">
                    <div class="item" v-for="(item, index) in suggestion.goods.slice(0, 8)" :key="index">
                      <router-link :to="`/detail/${item.id}-${item.color}`">
                        <div class="item-img">
                          <img :src="item.cover" alt="">
                        </div>
                        <div class="item-detail">
                          <div class="item-name">{{ item.name }}</div>
                          <div class="item-price">￥{{ item.price }}</div>
                        </div>
                      </router-link>
                    </div>
                  </div>
                  <div class="more-btn" @click="toSearch">查看更多</div>

                </div>
              </div>
            </div>
            <div class="account-box" :style="{ top: headerHeight + 'px' }" v-if="accountBoxVisible">
              <div class="account-box-wrapper">
                <div :class="['top-btn', isLogin ? 'logout' : 'login']">
                  <div class="btns" v-if="isLogin">
                    <div class="button default" @click="jumpTo('/account')">我的账户</div>
                    <div class="button normal" @click.prevent="logout">退出登录</div>
                  </div>
                  <div class="btns" v-else>
                    <div class="button primary" @click="jumpTo('/user/login')">登录</div>
                    <div class="button default" @click="jumpTo('/user/register')">注册会员</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- mobile -->
    <div class="menubar mobile">
      <div class="menu-wrapper">
        <div class="menu-main">
          <div class="menus" ref="menuBox">
            <div
              :class="['mob-menu-bar', mobileAccountDialogVisible ? 'account-visible' : '', mobileMenuDialogVisible ? 'menu-visible' : '']">
              <div class="left-menu item">
                <!-- <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 23 18" id="hamburger-menu" class="is-hide-icon"
                  @click="setMobileMenuDialog(true)">
                  <path
                    d="M22 10H1a1 1 0 1 1 0-2h21a1 1 0 0 1 0 2zm0-8H1a1 1 0 1 1 0-2h21a1 1 0 0 1 0 2zM1 16h21a1 1 0 0 1 0 2H1a1 1 0 1 1 0-2z" />
                </svg> -->
                <i class="iconfont-ot-website icon-menu is-hide-icon" @click="setMobileMenuDialog(true)">&#xe6a1;</i>

                <i class="iconfont-ot-website close left-close-icon" @click="setMobileMenuDialog(false)">&#xe6df;</i>
                <i class="iconfont-ot-website search-icon is-hide-icon" @click="setSearchContentVisible">&#xe690;</i>
              </div>
              <div class="middle-logo item">
                <router-link class="logo-link" to="/">
                  <i class="iconfont logo-icon">&#xe60e;</i>
                </router-link>
              </div>

              <div class="right-menu item">
                <router-link class="icon_text-item is-hide-icon" :to="{ name: 'Store-finder' }"
                  @click.native="closeMenu">
                  <i class="iconfont-ot-website">&#xe692;</i>
                </router-link>
                <i class="iconfont-ot-website is-hide-icon" @click="setMobileAccountDialogVisible">{{ isLogin ?
                  `&#xe693;` :
                  `&#xe693;` }}</i>
                <div class="icon_text-item is-hide-icon menu-cart-icon" @mouseover="showCartDialog" @click="toCart">
                  <i :class="['iconfont-ot-website cart']">&#xe691;</i>
                  <span v-if="cartCount > 0"
                    :class="['cart-count', { 'cart-count-2': cartCount > 9 && cartCount < 100 }, { 'cart-count-3': cartCount > 99 }]">{{
                      cartCount >
                        99 ? `99+` : cartCount }}</span>
                </div>
                <i class="iconfont-ot-website close right-close-icon"
                  @click="setMobileAccountDialogVisible">&#xe6df;</i>
              </div>
            </div>

            <div class="search-box" :style="{ top: drawerTop + 'px' }" v-if="searchBoxVisible">
              <div class="search-box-wrapper">
                <div class="search-top">
                  <div class="t-l">
                    <i class="iconfont-ot-website search" @click="toSearch">&#xe690;</i>
                    <input type="text" v-model.trim="kw" ref="searchIpt" :placeholder="placeholder" @input="quickSearch"
                      @keyup.enter="toSearch">
                  </div>
                  <div class="t-r">
                    <!-- <span class="del-default-key" @click="clearSearch">删除</span> -->
                    <i class="iconfont-ot-website close" @click="setSearchContentVisible">&#xe6a0;</i>
                  </div>
                </div>
                <div class="search-hot" v-if="!suggestion.goods.length">
                  <div class="label">热门搜索</div>
                  <div class="hot-search-list">
                    <div v-for="(item, index) in hotSearchList" :key="index">
                      <div class="item" @click="handleClickKey(item)"><a :href="item.link_url">{{ item.query_text }}</a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="search-bottom" v-if="suggestion.goods.length">
                  <div class="bottom-content">
                    <div class="product-list">
                      <div class="item" v-for="(item, index) in suggestion.goods.slice(0, 8)" :key="index">
                        <router-link :to="`/detail/${item.id}-${item.color}`">
                          <div class="item-img">
                            <img :src="item.cover" alt="">
                          </div>
                          <div class="item-detail">
                            <div class="item-name">{{ item.name }}</div>
                            <div class="item-price">￥{{ item.price }}</div>
                          </div>
                        </router-link>
                      </div>
                    </div>
                    <div class="more-btn" @click="toSearch">查看更多</div>
                  </div>
                </div>
              </div>
            </div>
            <div :class="['account-box', !isLogin ? 'logout' : 'login']" :style="{ top: drawerTop + 'px' }"
              v-if="accountBoxVisible">
              <div class="account-box-wrapper">
                <div :class="['top-btn', !isLogin ? 'logout' : 'login']">
                  <div class="btns" v-if="!isLogin">
                    <div class="button primary" @click="jumpTo('/user/login')">登录</div>
                    <div class="button default" @click="jumpTo('/user/register')">注册会员</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="page-tab mobile" :class="{ 'hidden-toolbar': isScrolled }">
        <div class="item" v-for="(item, pIndex) in PrimaryMenu" :key="pIndex" @click="handlePageTab(item)"
          :class="{ 'active': pageTabCode === item.code }">
          <a :href="item.link"><span>{{ item.title }}</span> </a>
        </div>
      </div>
    </div>
    <!-- mobile 菜单头部 -->
    <el-drawer size="100%" class="mobile-menu-dialog" :style="{ top: `${drawerTop}px` }" v-if="mobileMenuDialogVisible"
      v-show="getIsMobile" :modal="false" :show-close="false" :visible.sync="mobileMenuDialogVisible"
      :direction="direction">
      <nav class="nav-items">
        <div class="dialog-content">
          <div class="m-menu-1-list">
            <div :class="['m-menu-1-list-item',
              item.id === currentSelectedCategory.id ? 'active' : '',
            ]" v-for="(item, index) in featured.ProductAndBlock" :key="index" @click="handleSelectCategory(item)">{{
              item.name }}</div>
          </div>
        </div>
      </nav>
      <div class="mobile-menu-wrapper">
        <!-- 嵌套菜单组件 -->
        <div class="mobile-menu-body">
          <nested-menu :menu-data="currentSelectedCategory" :isLogin="isLogin" :featured="featured" :level="1" />
        </div>
      </div>>
    </el-drawer>
    <!-- mobile 已登录个人中心 -->
    <el-drawer size="100%" class="mobile-account-dialog" :style="{ top: `${drawerTop}px` }"
      v-if="mobileAccountDialogVisible" v-show="getIsMobile" :modal="false" :show-close="false"
      :visible.sync="mobileAccountDialogVisible" :direction="direction">
      <div class="account-box-wrapper">
        <div :class="['top-btn', isLogin ? 'logout' : 'login']">
          <div class="btns" v-if="isLogin">
            <div class="mob-account mobile">
              <div class="m-header">
                <div class="account-list">
                  <div class="item" v-for="(item, index) in mobAccountList" :key="index">
                    <a v-if="item.key === 'help'" class="udesk-go-service" @click="closeMenu">{{ item.label }}</a>
                    <router-link v-else :to="{ name: item.pathName }">{{ item.label
                    }}</router-link>
                    <i class="iconfont-ot-website">&#xe68f;</i>
                  </div>
                </div>
              </div>
            </div>
            <div class="button default" @click.prevent="logout">退出登录</div>
          </div>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import types from "@/store/types";
import api from "@/utils/api";
import utils from "@/utils";
import constantsConfig from "@/constants/config";
import { Message } from 'element-ui';
import NestedMenu from '@/components/MenuItem.vue';
import RecursiveMenu from '@/components/RecursiveMenu.vue'; // 添加这一行
import NotificationBar from '@/components/notificationBar.vue'; // 添加这一行

export default {
  components: {
    NestedMenu, RecursiveMenu, NotificationBar
  },
  data() {
    return {
      enableMarquee: false,
      msName: '',
      speed: 'middle',
      notice: '',
      noticeList: [],
      isScrolled: false,
      lastScrollTop: 0,
      ticking: false, // 用于节流
      menuList: [],
      kw: "",
      showSearchSuggestions: false,
      suggestion: {
        categories: [],
        goods: [],
      },
      showCartSummary: false,
      showMobileSearch: false,
      PrimaryMenu: constantsConfig.PrimaryMenu,
      pageTabCode: location.pathname,
      getIsMobile: false,
      searchBoxVisible: false,
      accountBoxVisible: false,
      hotSearchList: [],
      placeholder: '',
      mobileMenuDialogVisible: false,
      mobileAccountDialogVisible: false,
      direction: 'ltr',
      activeHoverItemId: null, // 用于跟踪当前悬停的菜单项ID
      currentSelectedCategory: {},
      featured: {
        ProductAndBlock: [],
        BlockOnly: []
      },
      drawerTop: 100,
      hideHeader: false,     // 新增：标记是否完全隐藏header
      scrollTimeout: null,   // 新增：用于延迟处理的timeout
      headerHeight: 0
    };
  },
  methods: {
    handleMenuItemHover(itemId) {
      this.activeHoverItemId = itemId;
    },
    handleMenuItemLeave() {
      this.activeHoverItemId = null;
    },

    handlePageTab() {
      if (location.pathname.includes('brand')) {
        this.pageTabCode = 'brand';
      } else {
        this.pageTabCode = 'shopping';
      }
    },
    getNavList() {
      api[types.GET_NAV_LIST]().then(res => {
        if (res?.code == 1) {
          this.notice = res.data?.notice;
          this.noticeList = res.data?.notice.list || [];
          const reMenu = res.data?.list.map(item => {
            // 深拷贝原始项
            const newItem = { ...item };

            // 如果有children且为数组
            if (newItem.children && Array.isArray(newItem.children)) {
              // 筛选出show_type为LP_Page_name的项
              const lpPageNameItems = newItem.children.filter(child =>
                child.show_type === 'LP_Page_name'
              );

              // 筛选出show_type为LP_Page_null的项
              const lpPageNullItems = newItem.children.filter(child =>
                child.show_type === 'LP_Page_null'
              );

              // 过滤掉上面两类项，保留其他children
              if (newItem.display_block === 'Product_and_Block') {
                newItem.children = newItem.children.filter(child =>
                  child.show_type !== 'LP_Page_name' && child.show_type !== 'LP_Page_null'
                );
              }

              // 如果找到了LP_Page_name项，则添加到newItem同级
              if (lpPageNameItems.length > 0) {

                newItem.LP_Page_name = lpPageNameItems[0];
              }

              // 如果找到了LP_Page_null项，则添加到newItem同级
              if (lpPageNullItems.length > 0) {
                newItem.LP_Page_null = lpPageNullItems[0];
              }

              // 如果children为空数组，则删除该属性
              if (newItem.children.length === 0) {
                delete newItem.children;
              }
            }

            return newItem;
          });
          this.menuList = reMenu;
          this.handleWindowResize();
          this.updateHeaderHeight()
          this.$store.commit('saveNavList', res.data);

        }
      }).catch(err => {
        console.warn(err);
      });
    },
    handleWindowResize() {
      const isMobile = window.innerWidth < 1024;
      if (isMobile) {
        this.extractFeaturedItems();
      }

      this.getIsMobile = isMobile
      this.getHeaderHeight()
    },
    handleGlobalClick() {
      // 检查账户弹框是否可见
      if (this.accountBoxVisible) {
        const accountBox = this.$el.querySelector('.account-box');
        const accountTrigger = this.$refs.accountIcon; // 使用 ref 获取元素

        // 检查点击目标是否在弹框内部或触发按钮上
        if (accountBox &&
          !accountBox.contains(event.target) &&
          accountTrigger !== event.target) {
          this.accountBoxVisible = false;
        }
      }
    },
    extractFeaturedItems() {
      // 假设您想要筛选 id 为 1 的菜单项中的特定子项
      // 这里需要根据您的具体需求调整逻辑
      if (this.menuList) {
        const reData = {
          ProductAndBlock: [],
          BlockOnly: []
        };

        this.menuList.forEach((item) => {
          if (item.display_block === 'Block_Only') {
            reData.BlockOnly.push(item);
          } else if (item.display_block === 'Product_and_Block') {
            reData.ProductAndBlock.push(item);
          }
        });
        this.featured = reData || [];
      }
    },

    getSearchHot() {
      api[types.GET_SEARCH_HOT]().then(res => {
        this.hotSearchList = res.data;
        this.placeholder = res.data[0]?.query_text;
      })
    },
    updateHeaderHeight() {
      this.$nextTick(() => {
        const header = document.querySelector('.ot-header');
        if (header) {
          this.headerHeight = header.offsetHeight;
        }
      });
    },
    handleScroll() {
      // 使用 requestAnimationFrame 节流
      this.updateHeaderHeight()
      if (!this.ticking) {
        requestAnimationFrame(() => {
          this.updateScrollState();
          this.ticking = false;
        });
        this.ticking = true;
      }
    },
    updateScrollState() {
      const currentScroll = window.scrollY;
      const scrollThreshold = 50;
      const scrollBuffer = 30; // 添加缓冲区避免频繁切换

      // 防止在临界值附近抖动
      if (Math.abs(currentScroll - scrollThreshold) < scrollBuffer) {
        this.lastScrollTop = currentScroll;
        return;
      }

      // 判断滚动方向：true表示向下滚动，false表示向上滚动
      const isScrollingDown = currentScroll > this.lastScrollTop;

      if (isScrollingDown && currentScroll > scrollThreshold) {
        // 明确向下滚动且超过阈值+缓冲区，隐藏
        this.isScrolled = true;
        const pageTabElement = document.querySelector('.menubar.desktop');
        if (pageTabElement) {
          const rect = pageTabElement.getBoundingClientRect();

          const pageTabBottom = rect.top;

          // 当page-tab底部距离视口顶部小于0时，显示header
          if (pageTabBottom < 0) {
            // 先隐藏header
            this.hideHeader = true;

            // 0.3秒后显示header
            this.scrollTimeout = setTimeout(() => {
              this.hideHeader = false;
            }, 300);
          }
        }

      }

      if (currentScroll < this.lastScrollTop && currentScroll < scrollThreshold - scrollBuffer) {
        // 向上滚动且低于阈值-缓冲区，显示
        this.isScrolled = false;
      }

      if (currentScroll <= scrollThreshold && this.lastScrollTop > scrollThreshold) {
        // 从下往上滚动回到阈值内时，直接显示header
        if (this.scrollTimeout) {
          clearTimeout(this.scrollTimeout);
        }
        this.hideHeader = false;
      }

      this.lastScrollTop = currentScroll;
    },

    handleSelectCategory(item) {
      const reData = { ...item };
      if (item.children && item.children.length > 0) {
        reData.children = [
          {
            "id": item.id,
            "parent_id": item.parent_id,
            "name": '查看全部',
            "cover": item.cover,
            "url": item.url,
            "show": item.show,
            "show_type": item.show_type,
            "display_block": item.display_block,
            "style": "font-size: 13px;"
          },
          ...item.children,
          item.LP_Page_null,
        ];
      }

      this.currentSelectedCategory = reData;
    },
    // 关闭菜单
    closeMenu() {
      let root = document.documentElement;
      if (root.classList.contains("menu-active")) {
        root.classList.remove("menu-active");
      }
      this.mobileMenuDialogVisible = false
    },
    // 退出
    logout() {
      this.$store.dispatch(types.LOGOUT, () => {
        this.initCart();
        this.$router.push({ name: "Home" });
      });
    },
    initCart() {
      this.$store.dispatch(types.GET_CART_INFO);
    },
    // 跳转到购物车
    toCart() {
      this.hideCartDialog();
      if (this.$route.fullPath == "/cart") return false;
      this.$router.push({ path: "/cart" });
    },
    // 显示搜索弹窗
    showSearchDialog() {
      this.showMobileSearch = true;
      this.$nextTick(() => {
        document.querySelector('.mobile-search-wrapper .search-form input')?.focus();
      })
    },
    // 关闭搜索弹窗
    hideSearchDialog() {
      this.showMobileSearch = false;
    },
    // 清除搜索
    clearSearch() {
      this.kw = '';
      this.placeholder = ''
      this.suggestion = {
        goods: [],
        categories: []
      }
    },
    // 搜索预览
    quickSearch() {
      if (!this.kw) {
        this.showSearchSuggestions = false;
        this.suggestion = { categories: [], goods: [] };
        return;
      }
      if (utils.regEmoji.test(this.kw)) {
        Message({
          message: '关键词中包含Emoji字符',
          type: "warning"
        });
        return;
      }
      // 根据关键词搜索
      api[types.SUGGESTION]({ keyword: this.kw }).then(res => {
        if (res?.code == 1) {
          this.suggestion = res.data;
          if (this.suggestion.categories?.length || this.suggestion.goods?.length) {
            this.showSearchSuggestions = false;
          } else {
            this.showSearchSuggestions = false;
          }
        } else {
          console.warn(res);
        }
      }).catch(err => {
        console.warn(err);
      });
    },
    // 跳转到搜索结果页
    toSearch() {
      if (!this.kw && !this.placeholder) {
        return false;
      }
      if (!this.kw) {
        this.kw = this.hotSearchList[0].query_text
      }
      if (utils.regEmoji.test(this.kw)) {
        Message({
          message: '关键词中包含Emoji字符',
          type: "warning"
        });
        return false;
      }
      this.showSearchSuggestions = false;
      this.showMobileSearch = false;
      this.closeMenu();
      this.$router.push({
        name: "Search",
        query: {
          kw: this.kw
        }
      });
    },
    handleClickKey(item) {
      if (item.link_url) return
      this.kw = item.query_text;
      this.toSearch();
    },
    setSearchContentVisible() {
      this.suggestion = {
        goods: [],
        categories: []
      }
      // this.kw = this.hotSearchList[0].query_text
      this.searchBoxVisible = !this.searchBoxVisible;
      if (this.accountBoxVisible) {
        this.accountBoxVisible = false;
      }
      if (this.mobileAccountDialogVisible) {
        this.mobileAccountDialogVisible = false;
      }
      if (!this.searchBoxVisible) {
        // this.kw = '';
        // 恢复背景滚动
        if (this.getIsMobile) {
          document.body.style.overflow = '';
        }
      } else {
        // 禁止背景滚动
        if (this.getIsMobile) {
          document.body.style.overflow = 'hidden';
        }
      }
    },
    setAccountContentVisible(e) {
      e.stopPropagation();
      this.accountBoxVisible = !this.accountBoxVisible;
      if (this.searchBoxVisible) {
        this.searchBoxVisible = false;
      }
    },
    setMobileAccountDialogVisible() {
      if (this.isLogin) {
        this.mobileAccountDialogVisible = !this.mobileAccountDialogVisible;
        if (this.searchBoxVisible) {
          this.searchBoxVisible = false;
        }
        this.disabledPageScroll(this.mobileAccountDialogVisible)
      } else {
        this.$router.push({
          name: "Login",
          query: {
            returnUrl: encodeURIComponent(this.$route.fullPath),
          },
        });
      }

    },
    setMobileMenuDialog(value) {
      this.disabledPageScroll(value)
      if (value) {
        this.searchBoxVisible = false
      }

      const ProductAndBlock = this.featured.ProductAndBlock[0]
      const reData = { ...ProductAndBlock };

      if (ProductAndBlock?.children && ProductAndBlock.children.length > 0) {
        reData.children = [
          {
            "id": ProductAndBlock.id,
            "parent_id": ProductAndBlock.parent_id,
            "name": '查看全部',
            "cover": ProductAndBlock.cover,
            "url": ProductAndBlock.url,
            "show": ProductAndBlock.show,
            "show_type": ProductAndBlock.show_type,
            "display_block": ProductAndBlock.display_block,
            "style": "font-size: 13px;"
          },
          ...ProductAndBlock?.children,
          ProductAndBlock.LP_Page_null,
        ];
      }
      this.currentSelectedCategory = reData;
      this.mobileMenuDialogVisible = value
    },
    disabledPageScroll(value) {
      if (!value) {
        // 恢复背景滚动
        document.body.style.overflow = '';
      } else {
        // 禁止背景滚动
        document.body.style.overflow = 'hidden';
      }
    },
    toShopping() {
      this.$router.push({ path: '/' });
    },
    jumpTo(path) {
      this.$router.push({ path: path });
    },
    showCartDialog() {
      if (utils.isMobile()) return false;
      this.showCartSummary = true;
    },
    hideCartDialog() {
      this.showCartSummary = false;
    },
    closeAllDialogs() {
      this.searchBoxVisible = false;
      this.accountBoxVisible = false;
      this.showCartSummary = false;
      this.showMobileSearch = false;
      this.mobileAccountDialogVisible = false
      this.mobileMenuDialogVisible = false
      // this.clearSearch()
      this.na
    },

    getHeaderHeight() {
      if (this.getIsMobile) {
        this.$nextTick(() => {
          setTimeout(() => {
            const menuWrapperRef = this.$refs.menuBox;
            const noticeBoxRef = this.$refs.noticeBox;

            // 更安全地获取高度值
            let height = 56; // 默认值

            if (menuWrapperRef && typeof menuWrapperRef.offsetHeight === 'number') {
              height = menuWrapperRef.offsetHeight || 57;
            }

            if (this.notice && this.notice.enable === 1) {
              let noticeH = 30;
              if (noticeBoxRef && noticeBoxRef.$el) {
                if (typeof noticeBoxRef.$el.offsetHeight === 'number') {
                  noticeH = noticeBoxRef.$el.offsetHeight || 0;
                }
              }
              height = height + noticeH;
            }
            this.drawerTop = height - 1;
          }, 100);
        })
      }
    },
  },
  mounted() {
    this.getNavList();
    this.initCart();
    this.getSearchHot()
    this.handlePageTab()
    this.updateHeaderHeight()
    window.addEventListener('scroll', this.handleScroll);
    // 添加窗口大小监听
    window.addEventListener('resize', this.handleWindowResize);
    // 添加全局点击事件监听器
    document.addEventListener('click', this.handleGlobalClick);

    // 初始检查
    this.handleWindowResize();
  },
  created() {
    if (this.isLogin) {
      this.$store.dispatch(types.GET_PROFILE);
    }
    // 函数防抖处理
    this.quickSearch = utils.debounce(this.quickSearch, 500);
    this.debouncedHandleScroll = utils.debounce(this.handleScroll, 50);
  },
  computed: {
    isLogin() {
      return this.$store.state.isLogin;
    },
    userInfo() {
      return this.$store.state.userInfo;
    },
    cartInfo() {
      return this.$store.state.cartInfo
    },
    cartCount() {
      return this.$store.state.cartInfo.list ? this.$store.state.cartInfo.list.reduce((a, b) => a + b.quantity, 0) : 0
    },
    isActive(item) {
      return '/' === item.link;
    },
    mobAccountList() {
      return this.$store.state.mobAccountList
    },
    isMobile() {
      return window.innerWidth <= 768;
    },
  },
  filters: {
    countify(items) {
      if (Array.isArray(items)) {
        return items.reduce((last, current) => last + current.quantity, 0);
      }
      return items
    }
  },
  watch: {
    // 监听路由变化
    $route() {
      // 路由变化时关闭所有弹窗
      this.closeAllDialogs();
      document.body.style.overflow = '';
      // 同时关闭移动端菜单
      this.closeMenu();
      this.handlePageTab()
    }
  },

  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('resize', this.handleWindowResize);
    document.body.style.overflow = '';
  },
};
</script>

<style lang='scss' scoped>
@media only screen and (min-width: 1024px) {
  .desktop {
    display: block;
  }

  .mobile {
    display: none;
  }

  .page-tab {
    display: flex;
    justify-content: center;
    align-items: center;
    border-top: 1px solid #babec2;
    border-bottom: 1px solid #babec2;
    background-color: #e7e8ea;
    box-sizing: border-box;
    transform: translateY(0);
    transition: transform 0.3s ease-in-out, height 0.3s ease-in-out, opacity 0s ease-in-out, border 0.3s ease-in-out;

    &.hidden-toolbar {
      transform: translateY(-100px);
      height: 0;
      opacity: 0;
      border: none;
      overflow: hidden;
    }

    .item {
      display: flex;
      padding: 10px 64px;
      justify-content: center;
      align-items: center;
      gap: 10px;
      flex-shrink: 0;
      cursor: pointer;
      border-right: 1px solid #babec2;
      position: relative;
      box-sizing: border-box;
      transition: background-color 0.3s ease-in-out;

      a {
        color: var(---, #212322);
        text-align: center;
        font-family: "Noto Sans CJK SC";
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: 22px;
        /* 150% */
        text-transform: uppercase;
      }



      /* 项间细分隔线 */
      &:first-child {
        border-left: 1px solid #CED0D3;
      }

      // &::after {
      //   content: '';
      //   position: absolute;
      //   bottom: -1px;
      //   background: #E6E8E9;
      //   left: 0;
      //   right: 0;
      //   height: 1px;
      //   transition: background-color 0.3s ease-in-out;
      // }

      &:hover {
        background-color: #fff;

        // border-bottom: none;
        &::after {
          content: '';
          position: absolute;
          bottom: -2px;
          background: #fff;
          left: 0;
          right: 0;
          height: 2px;
        }
      }

      &.active {
        background-color: #fff;

        &::after {
          content: '';
          position: absolute;
          bottom: -2px;
          background-color: #fff;
          left: 0;
          right: 0;
          height: 4px;
        }
      }

    }
  }
}


.iconfont {
  color: #000000;

  &.cart {
    position: relative;

    &.noempty {
      &::after {
        content: attr(data-count);
        height: 16px;
        line-height: 16px;
        min-width: 8px;
        padding: 0 4px;
        position: absolute;
        right: 0;
        top: -2px;
        font-size: 12px;
        font-weight: 700;
        color: #FFF;
        text-align: center;
        background: #000;
        border-radius: 8px;
      }
    }
  }
}

.col-1 {
  box-sizing: border-box;
  width: 100%;
}

.col-2 {
  box-sizing: border-box;
  width: 50%;
}

.col-3 {
  box-sizing: border-box;
  width: 33.3333%;
}

.col-4 {
  box-sizing: border-box;
  width: 25%;
}

input[type=search]::-webkit-search-cancel-button {
  -webkit-appearance: none;
}



.header {
  //设置层级 避免被内容遮盖
  position: relative;
  z-index: 1000; //内部header就是1000 保持1000
  position: unset;
  top: 0px;
  width: 100%;

  &.scroll-page-header {
    // 日本站 是 fixed，效果不好
    position: sticky;
    transform: translateY(0);
    transition: all .3s ease-in-out;
    box-shadow: 0 0 3px 0 rgba(0, 0, 0, .12);
    -webkit-box-shadow: 0 0 3px 0 rgba(0, 0, 0, .12);

    .desktop {
      .nav-item {
        padding: 14px !important;
      }
    }

  }



  &.hide-header {
    transform: translateY(-100%);
    // opacity: 0;
    overflow: hidden;
    transition: all 0s ease-in-out;
  }


  .toolbar {
    height: 30px;
    background: #000;
    // border-bottom: 1px solid #fff;
    transition: height 0.2s ease-in;
    position: relative;
    z-index: 2;

    .toolbar-box {
      box-sizing: border-box;
      max-width: 1200px;
      overflow: hidden;
      margin: 0 auto;
      position: relative;

      .notice-ot {
        // 

        .notice_body {
          display: inline-block;
          white-space: nowrap;

          .notice_text {
            display: inline-block;
            font-size: 12px;
            line-height: 30px;
            color: #fff;
            font-weight: 700;
            white-space: nowrap;
            // padding-right: 100px;
          }

          // &.marquee { transition: transform ;}
        }
      }
    }
  }

  .menubar {
    background-color: #FFFFFF;
    position: relative;
    transition: height 0.2s ease-in;


    .menu-wrapper {
      width: 100%;
      max-width: 1200px;
      margin: auto;
      // height: 100%;
      padding: 0 20px 0;
      // max-height: 72px;
      background-color: #FFFFFF;
      transition: left 0.2s ease-in;
      box-sizing: border-box;

      &.fixed {
        position: fixed;
      }

      .menu-main {
        // max-width: 1200px;
        // height: 72px;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .menus {
          display: flex;
          justify-content: space-between;
          flex-grow: 1;
          align-items: center;
        }

        .menu-toggle {
          display: none;
          position: absolute;
          top: 0;
          left: 0;
          width: 53px;
          // height: 72px;
          padding: 0 15px;
          border: none;
          background-color: #FFFFFF;
          fill: #000000;
          cursor: pointer;
        }

        .nav-left {
          display: flex;
          align-items: center;
          // padding-left: 10px;

          .logo-link {
            // height: 72px;
            display: flex;
            align-items: center;

            .logo-icon {
              font-size: 36px;
              color: #000000;
              width: auto;
            }
          }

          .nav-items {
            transition: left 0.2s ease-in, width 0.2s ease-in;
            position: static;

            .menu-items {
              height: 100%;
              list-style: none;
              color: #000000;
              text-align: center;
              font-size: 0;
              margin-left: 30px;
              display: flex;
              align-items: center;
              flex-direction: row;
              // gap: 10px;


              li {
                box-sizing: border-box;
                // height: 72px;
                display: inline-block;
                font-size: 16px;
                cursor: pointer;



                // border-bottom: 4px solid transparent;
                &.nav-item {
                  padding: 25px 10px;

                  &.hovered {

                    // 悬停时的样式
                    a {
                      &::after {
                        width: calc(100% + 20px); // 悬停时展开到全宽
                      }
                    }
                  }
                }

                a {
                  display: block;
                  padding: 8px 15px;
                  font-size: 14px;
                  color: #000000;
                  font-weight: bold;


                  position: relative;
                  text-decoration: none; // 去除默认下划线

                  &::after {
                    content: '';
                    position: absolute;
                    bottom: 2px; // 距离文字底部的距离
                    left: 0px;
                    right: 0;
                    width: 0;
                    height: 2px;
                    background-color: #212322;
                    transition: width 0.24s ease; // 添加过渡动画
                  }

                  &:hover {
                    // color: #fff;

                    &::after {
                      width: calc(100% + 20px); // 悬停时展开到全宽
                    }
                  }

                  span {
                    max-width: 100%;
                    margin-top: 4px;
                    font-size: 10px;
                    text-align: center;
                  }

                  img {
                    width: 100px;
                    height: 100px;
                    // margin: 0 25px;
                  }
                }

                .navs {
                  display: none;
                  width: 100%;
                  font-weight: 400;
                  text-align: left;
                  padding: 13px 20px;
                  cursor: pointer;

                  &:hover {
                    text-decoration: underline;
                  }
                }

                label.navs::after {
                  content: ">";
                  position: absolute;
                  right: 10px;
                }

                &:hover {
                  // border-bottom: 4px solid white;

                  .sub-menus {
                    display: block;
                    z-index: 99;
                  }

                  .recursive-menu-container {
                    display: block;
                  }
                }

                .sub-menus {
                  display: none;
                  width: 100%;
                  position: absolute;
                  top: 84px;
                  left: 0;
                  right: 0;
                  padding: 0px 50px 25px;
                  margin: auto;
                  background-color: #fff;
                  // box-shadow: 0 7px 22px 0 rgba(0, 0, 0, 0.2);

                  .menu-items {
                    box-sizing: border-box;
                    // max-width: 1260px;
                    // padding: 0 10px;
                    margin: 0 auto;
                    display: flex;
                    flex-wrap: wrap;
                    // padding-left: 97px;

                    li {
                      height: auto;

                      // &:hover { border: 0; }
                      &:first-child {
                        display: none;
                      }

                      a {
                        // width: 150px;
                        padding: 8px 0;
                        display: flex;
                        flex-direction: column;
                        color: #000;
                      }
                    }
                  }
                }
              }
            }

            .primary-menu>li>a {
              padding: 10px 14px;
            }
          }
        }

        .nav-right {
          display: flex;
          position: relative;

          .iconfont {
            cursor: pointer;
          }

          .nav-right-extra {
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            gap: 15px;

            .iconfont-ot-website {
              color: #212322;
              font-size: 27px;
            }

            .search-icon,
            .account-icon,
            .menu-cart-icon i,
            a.icon_text-item .iconfont-ot-website {
              width: 32px;
              height: 32px;
              display: inline-block;
              text-align: center;
              line-height: 32px;
              border-radius: 50%;
              position: relative;
              overflow: visible;
              z-index: 2;
            }

            .search-icon::before,
            .account-icon::before,
            .menu-cart-icon i::before,
            a.icon_text-item .iconfont-ot-website::before {
              content: "";
              position: absolute;
              left: 0;
              top: 0;
              width: 32px;
              height: 32px;
              background: #F5F5F5;
              border-radius: 50%;
              transform: scale(0);
              opacity: 0;
              z-index: -1;
              visibility: hidden;
              transition: all .35s ease-in-out;
              pointer-events: none;
            }

            .search-icon:hover::before,
            .account-icon:hover::before,
            .menu-cart-icon:hover i::before,
            a.icon_text-item:hover .iconfont-ot-website::before {
              transform: scale(1);
              opacity: 1;
              visibility: visible;
            }

            .menu-cart-icon {
              position: relative;
              line-height: 1;

              .cart-count {
                position: absolute;
                top: -2px;
                left: 50%;
                background: #212322;
                border-radius: 100px;
                color: #fff;
                font-size: 10px;
                width: 16px;
                height: 16px;
                line-height: 16px;
                display: flex;
                align-items: center;
                justify-content: center;
                text-align: center;
                font-family: "MatterSQ";
                padding: 0 0 0 1px;

                &.cart-count-2 {
                  width: 16px;
                  padding: 0 0px 1px 1px;

                }

                &.cart-count-3 {
                  width: 20px;
                  padding: 0 0px 1px 1px;
                }
              }
            }



            .iconfont-ot-website {
              cursor: pointer;
            }

            .icon_text-item {
              display: flex;
              flex-direction: column;

            }




          }

          .cart-summary {
            width: 400px;
            min-height: 95px;
            // max-height: 324px;
            position: absolute;
            top: 54px;
            right: 0px;
            background: #FFF;
            box-shadow: 0 7px 22px 0 rgba(0, 0, 0, .2);
            transition: all 0.3s ease-in;
            z-index: 100;

            .modal-header {
              position: relative;
              padding: 10px;
              // border-bottom: 1px solid #b4b5b4;

              .modal-header-text {
                font-size: calc(.875rem * 1.6);
                font-weight: 700;
                line-height: calc(1.375rem * 1.6);
                text-align: left;
              }

              .close {
                width: 15px;
                height: auto;
                position: absolute;
                top: 15px;
                right: 10px;
                cursor: pointer;
              }
            }

            .modal-body {
              .cart-summary-main {
                .cart-items {
                  overflow: scroll;
                  max-height: 350px;
                  margin: 0;
                  padding: 0;

                  .cart-item {
                    padding: 10px 0px;
                    margin: 0px 10px;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;

                    .cart-item-image {
                      width: 100px;
                      height: 100%;
                    }

                    .cart-item-detail {
                      padding: 0 10px;
                      text-align: left;
                      flex-grow: 1;

                      p {
                        font-size: calc(0.75rem * 1.6);
                        line-height: calc(1.375rem * 1.6);

                        &.bold {
                          font-weight: 700;
                        }
                      }
                    }

                    .cart-item-price {
                      font-weight: 700;
                      align-self: flex-start;
                    }
                  }
                }

                .cart-subtotal {
                  display: flex;
                  justify-content: space-between;
                  margin-bottom: 20px;
                  padding: 10px;
                  border-top: 1px solid #b4b5b4;
                  border-bottom: 1px solid #b4b5b4;

                  span {
                    font-size: calc(.875rem * 1.6);
                    line-height: calc(1.375rem * 1.6);
                    font-weight: 700;
                  }
                }

                .cart-actions {
                  padding-bottom: 10px;

                  a {
                    box-sizing: border-box;
                    display: block;
                    width: calc(100% - 20px);
                    margin: 0 auto 10px;
                    line-height: 38px;
                    padding: 0 30px;
                    font-size: calc(.875rem * 1.6);
                    letter-spacing: normal;
                    border-radius: 2px;
                    text-align: center;
                    text-decoration: none;
                    text-transform: uppercase;
                    transition: all .3s ease;
                    color: #fff;
                    background-color: #7f0019;
                    border: 1px solid #7f0019;
                    cursor: pointer;
                  }

                  button {
                    all: unset;
                    text-decoration: none;
                    color: #000;
                    display: block;
                    line-height: 38px;
                    font-size: calc(.875rem * 1.6);
                    letter-spacing: normal;
                    margin: 0 auto;
                    border-radius: 2px;
                    text-align: center;
                    transition: all .3s ease;
                    cursor: pointer;
                    background: transparent;

                    &:hover {
                      text-decoration: underline;
                    }
                  }
                }
              }

              .empty-hits {
                padding: 25px 10px;
                text-align: center;

                .title {
                  font-weight: 700;
                  font-size: calc(.875rem * 1.6);
                  line-height: calc(1.375rem * 1.6);
                  margin: 0;
                }

                .empty-msg {
                  font-size: calc(.75rem * 1.6);
                  line-height: calc(1.375rem * 1.6);

                  a {
                    color: #333;
                    font-size: calc(.875rem * 1.6);
                    text-decoration: underline;
                  }
                }
              }
            }

            &.no-more {
              .modal-header {
                padding: 0;

                .modal-header-text {
                  display: none;
                }
              }
            }
          }
        }

        .search-box,
        .account-box {
          position: fixed;
          background: #fff;
          // top: 84px;
          left: 0;
          right: 0;
          width: 100%;
          height: auto;
          // max-height: 60vh;
          z-index: 98;
          padding-bottom: 30px;
          display: flex;
          align-items: center;
          justify-content: center;


          .search-box-wrapper {
            width: 56%;
            max-width: 883px;
            background: #fff;
            display: flex;
            padding-top: 42px;
            align-items: flex-start;
            justify-content: center;
            flex-direction: column;
            gap: 24px;

            // margin: auto;
            .search-top {
              width: 100%;
              border: 1px solid var(---, #212322);

              display: flex;
              justify-content: space-between;
              align-items: center;
              padding: 10px;
              box-sizing: border-box;

              .iconfont-ot-website {
                font-size: 20px;
                color: #212322;
                margin-top: 2px;
              }

              .t-l {
                display: flex;
                align-items: center;
                flex: 1;
                gap: 10px;

                .iconfont-ot-website {
                  color: #989DA1;
                }

                input {
                  width: 100%;
                  font-size: 15px;
                  color: #212322;
                }

              }

              .t-r {
                display: flex;
                align-items: center;
                justify-content: flex-end;
                width: 80px;
                gap: 22px;


                .del-default-key {
                  text-decoration: underline;
                  cursor: pointer;
                  font-size: 15px;
                }

                .close {
                  font-weight: 600;
                  font-size: 24px;
                }
              }

              .iconfont,
              .close-icon,
              .close,
              .search {
                cursor: pointer;
              }
            }

            .search-hot {
              display: flex;
              flex-direction: column;
              gap: 10px;
              align-items: flex-start;

              .label {
                font-size: 16px;
                font-weight: 700;
              }

              .hot-search-list {
                display: flex;
                flex-direction: row;
                flex-wrap: wrap;
                gap: 15px;

                .item {
                  padding: 6px 12px;
                  background: #F8F8F8;
                  border-radius: 100px;
                  cursor: pointer;

                  a {
                    color: #212322;
                  }
                }
              }
            }

            .search-content {
              width: 100%;
              display: flex;
              align-items: center;
              justify-content: center;
              flex-direction: column;


              .product-list {
                display: flex;
                flex-wrap: wrap;
                align-items: center;
                justify-content: flex-start;
                width: 100%;
                margin-bottom: 20px;

                .item {
                  display: flex;
                  align-items: center;
                  flex-direction: column;
                  flex-wrap: wrap;
                  gap: 4px;
                  box-sizing: border-box;
                  flex: 0 1 25%;
                  padding: 25px;
                  cursor: pointer;

                  .item-img {
                    width: 100%;
                    max-height: 156px;
                    max-width: 156px;
                    height: 100%;

                    img {
                      width: 100%;
                      height: 100%;
                      display: block;
                    }
                  }

                  .item-detail {
                    display: flex;
                    flex-direction: column;
                    align-items: flex-start;
                    width: 100%;
                    gap: 2px;
                  }

                  .item-name {
                    color: #212322;
                    font-size: 14px;
                    font-weight: 500;
                    display: -webkit-box;
                    /* 必须设置为 flex 布局 */
                    -webkit-line-clamp: 2;
                    /* 限制显示两行 */
                    -webkit-box-orient: vertical;
                    /* 垂直布局 */
                    overflow: hidden;
                    /* 隐藏超出内容 */
                    text-overflow: ellipsis;
                    /* 显示省略号 */
                    white-space: normal;
                    text-align: left;
                    /* 允许换行 */

                  }

                  .item-price {
                    font-size: 14px;
                    font-weight: 400;
                    color: #212322;
                  }
                }
              }

              .more-btn {
                padding: 10px 30px;
                border-radius: 100px;
                border: 1px solid var(---, #212322);
                cursor: pointer;
                font-size: 14px;
                font-weight: 500;
                background: #212322;
                color: #fff;
                width: 16vw;

                &:hover {
                  background: #fff;
                  color: #212322;
                }
              }
            }
          }

          .account-box-wrapper {
            display: flex;
            width: 60%;
            background: #fff;
            align-items: center;
            justify-content: center;
            padding-top: 20px;


            .top-btn {


              .button {
                padding: 16px 114px;
                border-radius: 100px;
                border: 1px solid var(---, #212322);
                cursor: pointer;
                font-size: 18px;
                transition: all .3s ease-in-out;

                &.normal {
                  border: none;
                  padding: 0;
                  width: max-content;
                }

                &.default {

                  // border: none;
                  &:hover {
                    background: #212322;
                    color: #fff;
                  }
                }

                &.primary {
                  background: #212322;
                  color: #fff;
                  border: 1px solid var(---, #212322);

                  &:hover {
                    background: #fff;
                    color: #212322;
                  }
                }
              }

              &.logout {
                .btns {
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                  gap: 16px;
                }
              }

              &.login {
                .btns {
                  display: flex;
                  flex-direction: row;
                  gap: 40px;
                }
              }
            }
          }

        }
      }
    }
  }

  .dialog {
    .mask {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 1010;
      width: 100%;
      height: 100%;
      background: url(../assets/imgs/ui-overlay-shadow.png) repeat scroll 50% 50% #000;
      opacity: 0.3;
    }

    .dialog-container {
      box-sizing: border-box;
      position: fixed;
      z-index: 1011;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background: #FFF;
      min-width: 300px;
      max-width: 95%;
      min-height: 200px;
      border-radius: 4px;

      .dialog-header {
        position: relative;
        text-align: left;

        .dialog-close {
          width: 32px;
          height: 32px;
          position: absolute;
          top: -15px;
          right: -15px;
          z-index: 1;
          padding: 0;
          border: none;
          border-radius: 0;
          margin: 0;
          background-color: transparent;
          font-size: 0;
          cursor: pointer;

          .close-icon {
            background-image: url(../assets/imgs/icons/onitsukatiger-close.svg);
            background-position: center center;
            background-repeat: no-repeat;
            height: 32px;
            width: 32px;
            margin: 0;
            padding: 0;
            display: block;
            text-indent: -99999px;
            overflow: hidden;
          }
        }
      }

      .dialog-body {
        display: flex;
        box-sizing: border-box;
      }
    }

    &.mobile-search-wrapper {
      // display: none;

      .mask {
        opacity: 0.8;
      }

      .dialog-container {
        top: 0;
        left: 0;
        transform: translate(0, 0);
        width: 100%;
        max-width: 100%;
        min-height: 52px;
        border-radius: 0;

        .dialog-header {
          .dialog-close {
            top: 10px;
            right: 0px;

            .close-icon {
              background-image: url(../assets/imgs/icons/onitsukatiger-close2.svg);
            }
          }
        }

        .dialog-body {
          flex-direction: column;

          .form-wrapper {
            width: 100%;
            position: relative;

            .search-form {
              display: flex;
              width: 100%;

              input {
                width: 100%;
                height: 52px;
                border: 0;
                padding: 0 70px 0 10px;
                box-sizing: border-box;
                -webkit-appearance: none;
              }
            }

            .clear-search {
              margin-right: 42px;
              text-decoration: underline;
              height: 52px;
              line-height: 52px;
              cursor: pointer;
              position: absolute;
              top: 0px;
              right: 0px;
            }
          }

          .search-suggestions {
            width: 100%;
            position: relative;

            .search-suggestion-wrapper {
              background: #FFF;
              display: flex;

              .suggestion-items {
                box-sizing: border-box;
                width: 100%;
                height: 100%;
                padding: calc(.625rem * 1.6) calc(.625rem * 1.6) calc(1.25rem * 1.6);
                text-align: left;
                overflow: hidden;

                &:first-child {
                  border-right: 1px solid #b4b5b4;
                }

                .suggestion-header {
                  line-height: 24px;
                  font-weight: 700;
                  font-size: calc(1rem * 1.6);
                  letter-spacing: .025em;
                  margin: 20px 0 0;
                  color: #333;
                }

                &.suggestion-product {
                  .search-phrase {
                    font-size: calc(.875rem * 1.6);
                    color: #333;
                    line-height: 25px;
                    margin-top: 9px;

                    .suggestion-result {
                      font-size: calc(.75rem * 1.6);
                      letter-spacing: .025em;
                      color: #b4b5b4;

                      .original {
                        text-decoration: underline;
                        font-weight: 700;
                      }
                    }
                  }

                  .suggestion-item {
                    padding-top: 18px;

                    a {
                      display: flex;
                      width: 100%;

                      .item-image {
                        box-sizing: border-box;
                        width: 25%;
                        padding-right: 14px;

                        img {
                          width: 100%;
                          height: auto;
                        }
                      }

                      .item-detail {
                        width: 75%;
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        color: #000;

                        .item-name {
                          font-size: calc(1rem * 1.6);
                          font-weight: 700;
                          line-height: calc(1.375rem * 1.6);
                          white-space: nowrap;
                          text-overflow: ellipsis;
                          overflow: hidden;
                          word-break: break-all;

                        }

                        .item-category {
                          color: #000;
                          font-size: calc(.625rem * 1.6);
                        }

                        .item-price {
                          line-height: calc(1rem * 1.6);
                          font-weight: 700;
                          font-size: calc(.75rem * 1.6);
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

@media only screen and (max-width: 1024px) {
  .iconfont {
    color: #000000;
  }

  .header {

    // .toolbar { display: none; }
    .menubar {
      // height: 107px;
      // min-height: 72px;

      .menu-wrapper {
        max-height: unset;
        height: auto;

        .menu-main {
          flex-direction: column;
          // min-height: 72px;
          height: auto;

          .nav-left {
            padding-left: 0;

            .nav-items {
              position: fixed;
              z-index: 1000; //增加层级 不让其覆盖header及侧边栏
              top: 0;
              left: -50%;
              width: 50%;
              height: 100%;
              // overflow: hidden auto;
              background-color: #FFFFFF;
              display: flex;
              flex-direction: column;

              &>.menu-items {
                display: none;
                height: auto;
              }

              .menu-items {
                margin-left: 0;

                li {
                  width: 100%;
                  height: auto;
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                  border-bottom: 1px solid #b4b5b4;

                  a {
                    padding: 13px 20px;

                    &.link {
                      display: none;
                    }
                  }

                  .navs {
                    display: block;
                  }

                  .sub-menus {
                    box-shadow: none;

                    .menu-items {
                      display: flex;
                      flex-direction: column;
                      padding-left: 0;
                      background-color: #FFFFFF;

                      li {
                        a {
                          color: #000000;
                          width: 100%;
                          text-align: left;
                          padding: 13px 20px;

                          &.menu-back {
                            box-sizing: border-box;
                            text-align: center;

                            &::before {
                              content: "<";
                              position: absolute;
                              left: 20px;
                            }
                          }

                          span {
                            width: 100%;
                            max-width: 100%;
                            font-weight: 400;
                            text-align: left;
                          }
                        }

                        img {
                          display: none;
                        }

                        &:hover {
                          border-bottom: 1px solid #b4b5b4;
                        }
                      }
                    }
                  }

                  &:hover {
                    border-bottom: 1px solid #b4b5b4;

                    .sub-menus {
                      display: none;
                    }
                  }
                }
              }

              .m-footer {
                .col-1 {
                  padding-left: 20px;
                }
              }
            }
          }

          .nav-right {
            position: absolute;
            right: 15px;

            .nav-right-extra {
              width: auto;
              justify-content: flex-end;

              .search-icon,
              .account-icon,
              .menu-cart-icon i,
              a.icon_text-item .iconfont-ot-website {
                width: 32px;
                height: 32px;
                display: inline-block;
                text-align: center;
                line-height: 32px;
                border-radius: 50%;
                position: relative;
                z-index: 2;
                overflow: visible;
              }

              .search-icon::before,
              .account-icon::before,
              .menu-cart-icon i::before,
              a.icon_text-item .iconfont-ot-website::before {
                content: "";
                position: absolute;
                left: 0;
                top: 0;
                width: 32px;
                height: 32px;
                background: #F5F5F5;
                border-radius: 50%;
                transform: scale(0);
                opacity: 0;
                visibility: hidden;
                transition: all .35s ease-in-out;
                z-index: -1;
                pointer-events: none;
              }

              .search-icon:hover::before,
              .account-icon:hover::before,
              .menu-cart-icon:hover i::before,
              a.icon_text-item:hover .iconfont-ot-website::before {
                transform: scale(1);
                opacity: 1;
                visibility: visible;
              }


              a.icon_text-item {
                display: none;
              }

              .cart-summary-wrapper {
                .cart-summary {
                  top: 58px;
                  right: -20px;
                }
              }
            }
          }

          .menu-toggle {
            display: block;
          }
        }
      }
    }

    .dialog.mobile-search-wrapper {
      display: block;
    }
  }
}

@media only screen and (max-width: 1024px) {
  .desktop {
    display: none !important;
  }

  .mobile {
    display: block;
  }

  .header {
    .toolbar {
      height: 30px;
      background: #000;
      // border-bottom: 1px solid #fff;
      transition: height 0.2s ease-in;
      position: relative;
      z-index: 2;

      .toolbar-box {
        box-sizing: border-box;
        overflow: hidden;
        margin: 0 auto;
        position: relative;

        .notice-ot {
          // 

          .notice_body {
            display: inline-block;
            white-space: nowrap;

            .notice_text {
              display: inline-block;
              font-size: 12px;
              line-height: 30px;
              color: #fff;
              font-weight: 700;
              white-space: nowrap;
              // padding-right: 100px;
            }

            // &.marquee { transition: transform ;}
          }
        }
      }
    }

    .page-tab {
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-top: none;
      border-bottom: 2px solid #CED0D3;
      background: #fff;
      transform: translateY(0);
      transition: transform 0.2s ease-in-out, height 0.2s ease-in-out, opacity 0.35s ease-in-out, border 0.2s ease-in-out;

      &.hidden-toolbar {
        transform: translateY(-100px);
        opacity: 0;
        visibility: hidden;
        overflow: hidden;
        height: 0;
        border: none;
      }

      .item {
        display: flex;
        padding: 15px 0;
        justify-content: center;
        align-items: center;
        flex-shrink: 0;

        flex: 1;
        cursor: pointer;
        position: relative;

        a {
          color: var(---, #212322);
          text-align: center;
          font-family: "Noto Sans CJK SC";
          font-size: 12px;
          font-style: normal;
          font-weight: 700;
          line-height: normal;
          text-transform: uppercase;
        }


        &::after {
          content: '';
          position: absolute;
          bottom: -2px;
          background: #E6E8E9;
          left: 0;
          right: 0;
          height: 2px;
        }

        &.active {
          background-color: #fff;

          &::after {
            content: '';
            position: absolute;
            bottom: -2px;
            background: #000;
            left: 0;
            right: 0;
            height: 2px;
          }
        }

      }
    }

    .menu-cart-icon {
      position: relative;
      line-height: 1;

      .cart-count {
        position: absolute;
        top: -3px;
        left: 50%;
        background: #212322;
        border-radius: 100px;
        color: #fff;
        font-size: 10px;
        width: 16px;
        height: 16px;
        line-height: 16px;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        font-family: "MatterSQ";
        padding: 0 0 0 0px;

        &.cart-count-2 {
          width: 16px;
          padding: 0 1px 1px;

        }

        &.cart-count-3 {
          width: 20px;
          padding: 0 1px 1px;
        }
      }
    }

    .menubar {
      // height: 72px;
      background-color: #FFFFFF;
      position: relative;
      transition: height 0.2s ease-in;

      .menu-wrapper {
        width: 100%;
        // height: 100%;
        padding: 0 10px 0;
        // max-height: 72px;
        background-color: #FFFFFF;
        transition: left 0.2s ease-in;
        box-sizing: border-box;

        &.fixed {
          position: fixed;
        }

        .menu-main {
          margin: 0 auto;
          display: flex;
          justify-content: space-between;
          align-items: center;

          .menus {
            display: flex;
            justify-content: space-between;
            flex-grow: 1;
            align-items: center;
            width: 100%;

            .mob-menu-bar {
              display: flex;
              align-items: center;
              justify-content: center;
              flex-direction: row;
              justify-content: space-between;
              width: 100%;
              box-sizing: border-box;
              padding: 8px 10px 11px;

              .iconfont-ot-website {
                color: #212322;
              }

              .right-close-icon {
                display: none;
              }

              .left-close-icon {
                display: none;
              }

              &.account-visible {
                .is-hide-icon {
                  display: none;
                }

                .right-close-icon {
                  display: block;
                }
              }

              &.menu-visible {
                .is-hide-icon {
                  display: none;
                }

                .left-close-icon {
                  display: block;
                }
              }

              .iconfont-ot-website {
                font-size: 24px;
              }

              svg {
                width: 16px;
              }

              .logo-icon {
                font-size: 40px;
              }



              .middle-logo {
                flex: 1;

                .logo-icon {
                  font-size: 32px;
                  line-height: 1;
                }

              }

              .item {
                display: flex;
                align-items: center;
                justify-content: center;
                flex-direction: row;
                gap: 8px;
              }

              .left-menu,
              .right-menu {
                flex: 0 1 25%;
                box-sizing: border-box;
              }

              .left-menu {
                justify-content: flex-start;
              }

              .right-menu {
                justify-content: flex-end;
              }
            }
          }

          .menu-toggle {
            // display: none;
            // position: absolute;
            // top: 0;
            // left: 0;
            width: 53px;
            // height: 72px;
            padding: 0 15px;
            border: none;
            background-color: #FFFFFF;
            fill: #000000;
            cursor: pointer;
          }

          .nav-left {
            display: flex;
            align-items: center;
            // padding-left: 10px;

            .logo-link {
              // height: 72px;
              display: flex;
              align-items: center;

              .logo-icon {
                font-size: 36px;
                color: #000000;
                width: auto;
              }
            }

            .nav-items {
              transition: left 0.2s ease-in, width 0.2s ease-in;
              position: static;

              .m-header {
                flex-direction: column;
                justify-content: flex-start;
                align-items: flex-start;
                border-bottom: 1px solid #b4b5b4;
                padding-top: 20px;

                .col-1 {
                  display: flex;
                  justify-content: flex-start;
                  align-items: center;
                  padding: 13px 20px;



                  .iconfont {
                    width: 28px;

                    &.help {
                      font-size: 28px;
                      height: 17px;
                      line-height: 17px;
                    }
                  }

                  .iconfont+a {
                    margin-left: 10px;
                  }
                }
              }

              .menu-items {
                height: 100%;
                list-style: none;
                color: #000000;
                text-align: center;
                font-size: 0;
                margin-left: 30px;
                display: flex;
                align-items: center;
                flex-direction: row;
                // gap: 10px;

                li {
                  box-sizing: border-box;
                  // height: 72px;
                  display: inline-block;
                  font-size: 16px;
                  cursor: pointer;

                  // border-bottom: 4px solid transparent;
                  &.nav-item {
                    padding: 25px 10px;
                  }

                  a {
                    display: block;
                    padding: 8px 15px;
                    font-size: 14px;
                    color: #000000;
                    font-weight: bold;


                    position: relative;
                    text-decoration: none; // 去除默认下划线

                    &::after {
                      content: '';
                      position: absolute;
                      bottom: 2px; // 距离文字底部的距离
                      left: 10px;
                      right: 0;
                      width: 0;

                      height: 2px;
                      background-color: #212322;
                      transition: width 0.24s ease; // 添加过渡动画
                    }

                    &:hover {
                      // color: #fff;

                      &::after {
                        width: calc(100% - 20px); // 悬停时展开到全宽
                      }
                    }

                    span {
                      max-width: 100%;
                      margin-top: 4px;
                      font-size: 10px;
                      text-align: center;
                    }

                    img {
                      width: 100px;
                      height: 100px;
                      // margin: 0 25px;
                    }
                  }

                  .navs {
                    display: none;
                    width: 100%;
                    font-weight: 400;
                    text-align: left;
                    padding: 13px 20px;
                    cursor: pointer;

                    &:hover {
                      text-decoration: underline;
                    }
                  }

                  label.navs::after {
                    content: ">";
                    position: absolute;
                    right: 10px;
                  }

                  &:hover {
                    // border-bottom: 4px solid white;

                    .sub-menus {
                      display: block;
                      z-index: 99;
                    }
                  }

                  .sub-menus {
                    width: 100%;
                    position: absolute;
                    top: 84px;
                    left: 0;
                    padding: 25px 50px;
                    background-color: #fff;
                    // box-shadow: 0 7px 22px 0 rgba(0, 0, 0, 0.2);

                    .menu-items {
                      box-sizing: border-box;
                      // max-width: 1260px;
                      // padding: 0 10px;
                      margin: 0 auto;
                      display: flex;
                      flex-wrap: wrap;
                      // padding-left: 97px;

                      li {
                        height: auto;

                        // &:hover { border: 0; }
                        &:first-child {
                          display: none;
                        }

                        a {
                          // width: 150px;
                          padding: 8px 0;
                          display: flex;
                          flex-direction: column;
                          color: #000;
                        }
                      }
                    }
                  }
                }
              }

              .primary-menu>li>a {
                padding: 10px 14px;
              }
            }
          }

          .nav-right {
            display: flex;

            .iconfont {
              cursor: pointer;
            }

            .nav-right-extra {
              display: flex;
              flex-wrap: wrap;
              align-items: center;
              gap: 20px;



              .iconfont-ot-website {
                cursor: pointer;
              }

              .icon_text-item {
                display: flex;
                flex-direction: column;

              }

              .iconfont-ot-website {
                font-size: 24px;
              }




            }

            .cart-summary {
              width: 400px;
              min-height: 95px;
              // max-height: 324px;
              position: absolute;
              top: 60px;
              right: 50px;
              background: #FFF;
              box-shadow: 0 7px 22px 0 rgba(0, 0, 0, .2);
              transition: all 0.3s ease-in;
              z-index: 100;

              .modal-header {
                position: relative;
                padding: 10px;
                border-bottom: 1px solid #b4b5b4;

                .modal-header-text {
                  font-size: calc(.875rem * 1.6);
                  font-weight: 700;
                  line-height: calc(1.375rem * 1.6);
                  text-align: left;
                }

                .close {
                  width: 15px;
                  height: auto;
                  position: absolute;
                  top: 30px;
                  right: 10px;
                  cursor: pointer;
                }
              }

              .modal-body {
                .cart-summary-main {
                  .cart-items {
                    overflow: scroll;
                    max-height: 350px;
                    margin: 0;
                    padding: 0;

                    .cart-item {
                      padding: 10px 0px;
                      margin: 0px 10px;
                      display: flex;
                      justify-content: space-between;
                      align-items: center;

                      .cart-item-image {
                        width: 100px;
                        height: 100%;
                      }

                      .cart-item-detail {
                        padding: 0 10px;
                        text-align: left;
                        flex-grow: 1;

                        p {
                          font-size: calc(0.75rem * 1.6);
                          line-height: calc(1.375rem * 1.6);

                          &.bold {
                            font-weight: 700;
                          }
                        }
                      }

                      .cart-item-price {
                        font-weight: 700;
                        align-self: flex-start;
                      }
                    }
                  }

                  .cart-subtotal {
                    display: flex;
                    justify-content: space-between;
                    margin-bottom: 20px;
                    padding: 10px;
                    border-top: 1px solid #b4b5b4;
                    border-bottom: 1px solid #b4b5b4;

                    span {
                      font-size: calc(.875rem * 1.6);
                      line-height: calc(1.375rem * 1.6);
                      font-weight: 700;
                    }
                  }

                  .cart-actions {
                    padding-bottom: 10px;

                    a {
                      box-sizing: border-box;
                      display: block;
                      width: calc(100% - 20px);
                      margin: 0 auto 10px;
                      line-height: 38px;
                      padding: 0 30px;
                      font-size: calc(.875rem * 1.6);
                      letter-spacing: normal;
                      border-radius: 2px;
                      text-align: center;
                      text-decoration: none;
                      text-transform: uppercase;
                      transition: all .3s ease;
                      color: #fff;
                      background-color: #7f0019;
                      border: 1px solid #7f0019;
                      cursor: pointer;
                    }

                    button {
                      all: unset;
                      text-decoration: none;
                      color: #000;
                      display: block;
                      line-height: 38px;
                      font-size: calc(.875rem * 1.6);
                      letter-spacing: normal;
                      margin: 0 auto;
                      border-radius: 2px;
                      text-align: center;
                      transition: all .3s ease;
                      cursor: pointer;
                      background: transparent;

                      &:hover {
                        text-decoration: underline;
                      }
                    }
                  }
                }

                .empty-hits {
                  padding: 25px 10px;
                  text-align: center;

                  .title {
                    font-weight: 700;
                    font-size: calc(.875rem * 1.6);
                    line-height: calc(1.375rem * 1.6);
                    margin: 0;
                  }

                  .empty-msg {
                    font-size: calc(.75rem * 1.6);
                    line-height: calc(1.375rem * 1.6);

                    a {
                      color: #333;
                      font-size: calc(.875rem * 1.6);
                      text-decoration: underline;
                    }
                  }
                }
              }

              &.no-more {
                .modal-header {
                  padding: 0;

                  .modal-header-text {
                    display: none;
                  }
                }
              }
            }
          }

          .search-box,
          .account-box {
            position: fixed;
            background: #fff;
            // top: 87px !important;
            left: 0;
            right: 0;
            width: 100%;
            height: auto;
            z-index: 98;
            padding-bottom: 30px;
            padding-top: 10px;
            display: flex;
            align-items: center;
            justify-content: center;

            .search-box-wrapper {
              width: 100%;
              background: #fff;
              display: flex;
              padding: 0px 15px 0px;
              box-sizing: border-box;
              align-items: flex-start;
              justify-content: center;
              flex-direction: column;
              gap: 20px;

              // margin: auto;
              .search-top {
                width: 100%;
                border: 1px solid var(---, #212322);

                display: flex;
                justify-content: space-between;
                align-items: center;
                padding: 8px 10px;
                box-sizing: border-box;

                .iconfont-ot-website {
                  font-size: 20px;
                  color: #212322;
                  margin-top: 2px;
                }

                .t-l {
                  display: flex;
                  align-items: center;
                  flex: 1;
                  gap: 10px;

                  .iconfont-ot-website {
                    color: #666;
                  }

                  input {
                    width: 100%;
                    font-size: 15px;
                    color: #212322;
                  }

                }

                .t-r {
                  display: flex;
                  align-items: center;
                  justify-content: flex-end;
                  width: 60px;
                  gap: 12px;


                  .del-default-key {
                    text-decoration: underline;
                    cursor: pointer;
                  }
                }

                .iconfont,
                .close-icon,
                .close,
                .search {
                  cursor: pointer;
                }
              }

              .search-hot {
                display: flex;
                flex-direction: column;
                gap: 10px;
                align-items: flex-start;

                .label {
                  font-size: 16px;
                  font-weight: 700;
                }

                .hot-search-list {
                  display: flex;
                  flex-direction: row;
                  flex-wrap: wrap;
                  gap: 15px;

                  .item {
                    padding: 6px 12px;
                    background: #F8F8F8;
                    border-radius: 100px;
                    cursor: pointer;

                    a {
                      color: #212322;
                      font-size: 12px;
                    }
                  }
                }
              }

              .search-bottom {
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                flex-direction: column;

                min-height: auto;
                overflow: hidden;


                .bottom-content {
                  height: calc(100vh - 208px);
                  padding-bottom: 100px;
                  margin-bottom: 20px;
                  overflow-y: auto;
                  -webkit-overflow-scrolling: touch;
                }


                .product-list {
                  display: flex;
                  flex-wrap: wrap;
                  align-items: center;
                  justify-content: flex-start;
                  width: 100%;
                  margin-bottom: 20px;

                  .item {
                    display: flex;
                    align-items: center;
                    flex-direction: column;
                    flex-wrap: wrap;
                    gap: 4px;
                    box-sizing: border-box;
                    flex: 0 1 50%;
                    padding: 20px 10px;
                    cursor: pointer;

                    .item-img {
                      width: 100%;
                      height: 100%;

                      img {
                        width: 100%;
                        height: 100%;
                        display: block;
                      }
                    }

                    .item-detail {
                      display: flex;
                      flex-direction: column;
                      align-items: flex-start;
                      width: 100%;
                      gap: 2px;
                    }

                    .item-name {
                      color: #212322;
                      font-size: 14px;
                      font-weight: 500;
                      display: -webkit-box;
                      /* 必须设置为 flex 布局 */
                      -webkit-line-clamp: 2;
                      /* 限制显示两行 */
                      -webkit-box-orient: vertical;
                      /* 垂直布局 */
                      overflow: hidden;
                      /* 隐藏超出内容 */
                      text-overflow: ellipsis;
                      /* 显示省略号 */
                      white-space: normal;
                      text-align: left;
                      /* 允许换行 */

                    }

                    .item-price {
                      font-size: 14px;
                      font-weight: 400;
                      color: #212322;
                    }
                  }
                }

                .more-btn {
                  padding: 16px 30px;
                  border-radius: 100px;
                  border: 1px solid var(---, #212322);
                  cursor: pointer;
                  font-size: 14px;
                  font-weight: 500;
                  background: #212322;
                  color: #fff;
                  width: 100%;
                  margin: 40px auto 20px;
                  box-sizing: border-box;

                  &:hover {
                    background: #fff;
                    color: #212322;
                  }
                }
              }
            }

            .account-box-wrapper {
              display: flex;
              width: 100%;
              height: 100%;
              background: #fff;
              align-items: flex-start;
              justify-content: center;
              padding-top: 0px;


              .account-list {
                display: flex;
                align-items: flex-start;
                flex-direction: column;
                // padding: 0 10px;
                box-sizing: border-box;
                margin-bottom: 60px;

                .item {
                  // padding: 14px 0;
                  text-align: left;
                  border-bottom: 1px solid var(--web, #CED0D3);
                  width: 100%;
                  box-sizing: border-box;
                  display: flex;
                  justify-content: space-between;
                  align-items: center;

                  // .col-1 {
                  //   padding: 14px 0;
                  // }
                  .udesk-go-service {
                    width: 100%;
                    display: block;
                  }

                  a {
                    padding: 14px 0;
                    color: #212322;
                    font-weight: 700;
                    font-size: 14px;
                    width: 100%;
                    display: block;
                  }

                  .iconfont-ot-website {
                    font-size: 12px;
                  }
                }
              }

              .top-btn {
                width: 90%;

                .button {
                  padding: 14px 30px;
                  border-radius: 100px;
                  border: 1px solid var(---, #212322);
                  cursor: pointer;
                  font-size: 14px;
                  width: 100%;
                  box-sizing: border-box;

                  &.normal {
                    border: none;
                    padding: 0;
                    width: max-content;
                  }

                  &.default {

                    // border: none;
                    &:hover {
                      background: #212322;
                      color: #fff;
                    }
                  }

                  &.primary {
                    background: #212322;
                    color: #fff;
                    border: 1px solid var(---, #212322);

                    &:hover {
                      background: #fff;
                      color: #212322;
                    }
                  }
                }

                &.logout {
                  .btns {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    gap: 16px;

                    .mob-account {
                      width: 100%;
                    }
                  }
                }

                &.login {
                  .btns {
                    display: flex;
                    flex-direction: column;
                    gap: 15px;
                  }
                }
              }
            }

          }

          .account-box {
            &.logout {
              height: 100vh;
            }

            .login {}
          }
        }
      }
    }

    .mobile-menu-dialog {
      top: 100px;
      height: calc((100vh - 50px));
      // overflow: auto;

      &::v-deep .el-drawer__header {
        display: none;
      }


      .m-menu-1-list {
        display: flex;
        align-items: center;
        flex-direction: row;
        margin-bottom: 1px;

        &-item {
          flex: 1;
          padding: 15px 0;
          border-bottom: 2px solid var(---, #D3D3D5);
          line-height: 1.2;
          font-weight: 700;

          &.active {
            border-bottom: 2px solid var(---, #212322);
          }
        }
      }

      .m-menu-2-list {
        display: flex;
        width: 100%;
        justify-content: space-between;
        align-items: center;
        flex-direction: column;
        padding: 0px 15px;
        box-sizing: border-box;

        &-item {
          flex: 1;
          border-bottom: 1px solid var(---, #D3D3D5);
          line-height: 1;
          font-size: 14px;
          font-weight: 600;
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-between;
          color: #212322;

          .item-name {
            width: 100%;
            text-align: left;

            a {
              display: block;
              width: 100%;
              padding: 14px 0;
              color: #212322;

            }

            span {
              width: 100%;
              color: #212322;

            }
          }

          .iconfont-ot-website {
            font-size: 12px;
          }
        }

      }









      .nav-items {


        &>.menu-items {
          height: auto;
        }

        .menu-items {
          margin-left: 0;

          li {
            width: 100%;
            height: auto;
            display: flex;
            justify-content: space-between;
            align-items: center;
            border-bottom: 1px solid #b4b5b4;

            a {
              padding: 13px 20px;

              &.link {
                display: none;
              }
            }

            .navs {
              display: block;
            }

            .sub-menus {
              box-shadow: none;
              width: 100%;

              .menu-items {
                display: flex;
                flex-direction: column;
                padding-left: 0;
                background-color: #FFFFFF;

                li {
                  a {
                    color: #000000;
                    width: 100%;
                    text-align: left;
                    padding: 13px 20px;

                    &.menu-back {
                      box-sizing: border-box;
                      text-align: center;

                      &::before {
                        content: "<";
                        position: absolute;
                        left: 20px;
                      }
                    }

                    span {
                      width: 100%;
                      max-width: 100%;
                      font-weight: 400;
                      text-align: left;
                    }
                  }

                  img {
                    display: none;
                  }

                  &:hover {
                    border-bottom: 1px solid #b4b5b4;
                  }
                }
              }
            }

            &:hover {
              border-bottom: 1px solid #b4b5b4;

              .sub-menus {
                display: none;
              }

              .recursive-menu-container {
                display: block;
              }
            }
          }
        }

        .m-footer {
          .col-1 {
            padding-left: 20px;
          }
        }
      }
    }

    .mobile-account-dialog {
      top: 100px;
      background: #fff;
      height: calc((100vh - 50px));

      &::v-deep .el-drawer__header {
        display: none;
      }

      .account-box-wrapper {
        display: flex;
        width: 100%;
        height: 100%;
        align-items: flex-start;
        justify-content: center;
        padding-top: 0px;


        .account-list {
          display: flex;
          align-items: flex-start;
          flex-direction: column;
          // padding: 0 10px;
          box-sizing: border-box;
          margin-bottom: 60px;
          background: #fff;

          .item {
            // padding: 14px 0;
            text-align: left;
            border-bottom: 1px solid var(--web, #BBBEC2);
            width: 100%;
            box-sizing: border-box;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .col-1 {
              padding: 14px 0;
            }

            a {
              padding: 14px 0;
              color: #212322;
              font-weight: 700;
              font-size: 14px;
              width: 100%;
            }

            .iconfont-ot-website {
              font-size: 12px;
              color: #000000;
              font-weight: 600;
            }
          }
        }

        .top-btn {
          width: 90%;

          .button {
            padding: 14px 30px;
            border-radius: 100px;
            border: 1px solid var(---, #212322);
            cursor: pointer;
            font-size: 14px;
            width: 100%;
            box-sizing: border-box;

            &.normal {
              border: none;
              padding: 0;
              width: max-content;
            }

            &.default {

              // border: none;
              &:hover {
                background: #212322;
                color: #fff;
              }
            }

            &.primary {
              background: #212322;
              color: #fff;
              border: 1px solid var(---, #212322);

              &:hover {
                background: #fff;
                color: #212322;
              }
            }
          }

          &.logout {
            .btns {
              display: flex;
              flex-direction: column;
              align-items: center;
              gap: 16px;

              .mob-account {
                width: 100%;
              }
            }
          }

          &.login {
            .btns {
              display: flex;
              flex-direction: column;
              gap: 15px;
            }
          }
        }
      }
    }

  }

  .mobile-menu-dialog {
    .mobile-menu-wrapper {
      height: 100%;
      display: flex;
      flex-direction: column;
    }

    .mobile-menu-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 15px 20px;
      border-bottom: 1px solid #eee;
      background: #fff;
      flex-shrink: 0;

      .menu-title {
        font-size: 18px;
        font-weight: bold;
      }

      .close-icon {
        font-size: 20px;
        cursor: pointer;
      }
    }

    .mobile-menu-body {
      flex: 1;
      overflow-y: auto;
      position: relative;
    }
  }
}
</style>
